
import { http } from './index'

export async function getMyVacancies(params:any) {
    return await http.get<any>('/api/vacancy/created-by-me/', { params })
}

export async function confirmAssignation(id:string, userId: string) {
    const data = { user_id: userId }
    return await http.post<any>(`/api/vacancy/${id}/confirm-assignation/`, data)
}

export async function rejectAssignation(id:string, userId: string) {
    const data = { user_id: userId }
    return await http.post<any>(`/api/vacancy/${id}/reject-response/`, data)
}

export async function createVacancy(data:any) {
    return await http.post<any>(`/api/vacancy/`, data)
}

export async function createVacancyPack(data:any) {
    return await http.post<any>(`/api/vacancy/bulk-create/`, data)
}

export async function confirmVacancyPack() {
    return await http.post<any>(`/api/vacancy/bulk-confirm-first-responders/`)
}

export async function editVacancy(data:any) {
    return await http.put<any>(`/api/vacancy/${data.id}/`, data)
}

export async function deleteVacancy(id:string, data: any) {
    return await http.delete<any>(`/api/vacancy/${id}/`, { data })
}

export async function getSkills() {
    return await http.get<any>('/api/skill/')
}

export async function getMyDepartments(params:any) {
    return await http.get<any>('/api/departments/me/', {params})
}

export async function getError() {
    return await http.get<any>('/api/erorrrr/')
}

export async function getRequests(params:any) {
    return await http.get<any>('/api/vacancy/requests/', { params })
}

export async function requestReject(id:any) {
    return await http.patch<any>(`/api/vacancy/${id}/`, {is_request_rejected: true})
}

export async function getAvailableEmployees(data:any) {
    const { id, start, end } = data 
    
    return await http.get<any>(`/api/departments/${id}/available-employees`, {
        params: {
            dttm_work_start_at: start,
            dttm_work_end_at: end
        }
    })
}

export async function getVacancyArchive(params:any) {
    return await http.get<any>('/api/vacancy/archive/', { params })
}

export async function getOutsourceReport(data:any) {
    return await http.post<any>(`/api/report/outsource/`, data, {
        responseType: 'blob'
    })
}

export async function getVacancyHistory(id:string) {
    return await http.get<any>(`/api/vacancy/${id}/history/`)
}

// RD-164: вызовы новой страницы биржи. Ошибки показывает локальный обработчик биржи,
// поэтому глобальный тост interceptor подавлен (401/403 обрабатываются как раньше).
const quiet = { suppressGlobalErrorToast: true }

export async function getExchangeList(path: 'created-by-me' | 'requests' | 'archive', params: Record<string, string | number | boolean>) {
    return await http.get<any>(`/api/vacancy/${path}/`, { params, ...quiet })
}

// target-contract §5 — GET /api/vacancy/summary/
export async function getVacancySummary(params: Record<string, string | number | boolean>) {
    return await http.get<any>('/api/vacancy/summary/', { params, ...quiet })
}

export async function postVacancy(data: Record<string, unknown>) {
    return await http.post<any>('/api/vacancy/', data, quiet)
}

// target-contract §1 — вариант dates с обязательным Idempotency-Key.
export async function postVacancyBatch(data: Record<string, unknown>, idempotencyKey: string) {
    return await http.post<any>('/api/vacancy/bulk-create/', data, { ...quiet, headers: { 'Idempotency-Key': idempotencyKey } })
}

export async function postConfirmAssignation(id: string, userId: string) {
    return await http.post<any>(`/api/vacancy/${id}/confirm-assignation/`, { user_id: userId }, quiet)
}

export async function postRejectResponse(id: string, userId: string) {
    return await http.post<any>(`/api/vacancy/${id}/reject-response/`, { user_id: userId }, quiet)
}

export async function patchRejectRequest(id: string) {
    return await http.patch<any>(`/api/vacancy/${id}/`, { is_request_rejected: true }, quiet)
}

export async function putVacancy(id: string, data: Record<string, unknown>) {
    return await http.put<any>(`/api/vacancy/${id}/`, data, quiet)
}

export async function deleteVacancyWithReason(id: string, reason: string) {
    return await http.delete<any>(`/api/vacancy/${id}/`, { data: { deletion_reason: reason }, ...quiet })
}

export async function getVacancyHistoryQuiet(id: string) {
    return await http.get<any>(`/api/vacancy/${id}/history/`, quiet)
}

export async function getAvailableEmployeesQuiet(departmentId: string, start: string, end: string) {
    return await http.get<any>(`/api/departments/${departmentId}/available-employees`, {
        params: { dttm_work_start_at: start, dttm_work_end_at: end },
        ...quiet
    })
}

export async function getOutsourceReportQuiet(data: Record<string, unknown>) {
    return await http.post<any>('/api/report/outsource/', data, { responseType: 'blob', ...quiet })
}
